import { allergenDeclaration, AllergenState } from '../../recipes/recipeAllergenPresentation';
import type { Recipe } from '../../../services/recipes/recipesService';
import { ALLERGEN_SUBTYPES } from '../../../types/RecipeAllergens';
import { ALLERGIES, Allergy } from '../../../types/RecipeEnums';
import { normalizeSearch, recipeMatchesSearch } from './recipeViewerRecipeUtils';

export const SUBTYPE_CODES: Record<string, string> = {
  wheat: 'W', rye: 'R', barley: 'B', oats: 'O', almond: 'A', hazelnut: 'H', walnut: 'W',
  cashew: 'C', pecan: 'P', brazil_nut: 'B', pistachio: 'Pi', macadamia: 'M',
};
export { allergenDeclaration } from '../../recipes/recipeAllergenPresentation';
export type SelectionResult = 'browse' | AllergenState;

export function validAllergenSelection(value: string): boolean {
  const parts = value.split(':');
  const [parent, subtype] = parts;
  return parts.length <= 2 && ALLERGIES.includes(parent as Allergy) &&
    (subtype === undefined || !!ALLERGEN_SUBTYPES[parent as Allergy]?.includes(subtype));
}

export function classifyAllergenSelection(recipe: Recipe, selected: string[], stale = false): SelectionResult {
  if (!selected.length) return 'browse';
  let unknown = false;
  for (const selection of selected) {
    if (!validAllergenSelection(selection)) { unknown = true; continue; }
    const [parent, subtype] = selection.split(':');
    const declaration = allergenDeclaration(recipe, parent as Allergy, stale);
    if (declaration.state === 'contains') {
      if (!subtype || declaration.subtypes.includes(subtype)) return 'contains';
      if (!declaration.complete || !declaration.reviewed) unknown = true;
    } else if (declaration.state === 'unknown') unknown = true;
  }
  return unknown ? 'unknown' : 'absent';
}

export function allergenSearchMatches(recipe: Recipe, query: string, label: (key: string) => string): boolean {
  if (recipeMatchesSearch(recipe, query)) return true;
  const normalized = normalizeSearch(query);
  return ALLERGIES.some(parent => {
    const declaration = allergenDeclaration(recipe, parent);
    return declaration.state === 'contains' && [parent, label(parent),
      ...declaration.subtypes.flatMap(value => [value.replace(/_/g, ' '), label(value)]),
    ].some(text => normalizeSearch(text).includes(normalized));
  });
}

export function allergenCellCode(recipe: Recipe, parent: Allergy, stale = false): string {
  const declaration = allergenDeclaration(recipe, parent, stale);
  if (declaration.state !== 'contains') return '';
  return declaration.subtypes.map(value => SUBTYPE_CODES[value]).join(', ') || '+';
}
